import { createReducer, on, Action } from '@ngrx/store';

import { ReportModuleState, ReportSelection } from '../../models/report.model';
import * as reportActions from '../actions/report.actions';

export const initialState = <ReportModuleState>{
  isLoaded: false,
  selectedReport: undefined,
};

const reportReducer = createReducer(
  initialState,
  on(reportActions.clearReportState, (_) => initialState),
  on(reportActions.loadTimeSeriesSuccess, (state, { timeSeries }) => ({
    ...state,
    timeSeries,
  })),
  on(reportActions.setNormalizedFlockDataObject, (state, { normalizedFlockDataObject }) => ({
    ...state,
    normalizedFlockDataObject,
  })),
  on(reportActions.setSelectedReport, (state, { reportSelection }) => ({
    ...state,
    selectedReport: reportSelection,
  })),
  on(reportActions.clearSelectedReport, (state) => ({
    ...state,
    selectedReport: undefined as ReportSelection,
  })),
);

export function reducer(state: ReportModuleState | undefined, action: Action) {
  return reportReducer(state, action);
}
